<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-clock text-warning-cust" lab="公開待ちの案件" lab2="随時・0時後更新" :lab3="getCmpProjHome.data.waiting.toString()" lab4="件" @do_click="toWaiting"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-hourglass-end text-danger" lab="期限過ぎた案件" lab2="0時後更新/終了に設定" :lab3="getCmpProjHome.data.timeout.toString()" lab4="件" @do_click="toTimeout"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-comment text-success" lab="募集中の案件" lab2="個人・再委託可" :lab3="getCmpProjHome.data.opening.toString()" lab4="件" @do_click="toOpening"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fab fa-sketch text-primary" lab="内部案件" lab2="貴社社員まで" :lab3="getCmpProjHome.data.private.toString()" lab4="件" @do_click="toPrivate"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-comment-slash text-danger" lab="募集終了の案件" :lab3="getCmpProjHome.data.closing.toString()" lab4="件" @do_click="toClosing"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-trash text-danger" lab="削除待ちの案件" lab2="0時後物理削除(月末)" :lab3="getCmpProjHome.data.delete.toString()" lab4="件" @do_click="toDelete"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-eye-slash text-danger" lab="閲覧制限の案件" :lab3="getCmpProjHome.data.accesslimit.toString()" lab4="件" @do_click="toAccessLimit"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-chart-bar text-success" lab="会社分析"  @do_click="toCmpGraph"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-chart-pie text-success" lab="言語分析"  @do_click="toLangGraph"></page-nav>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import PageNav from 'pages/commons/nav/PageNav'

    export default {
        components: {
            PageNav
        },
        computed: {
            ...mapGetters(['getCmpProjHome'])
        },
        methods: {
            toWaiting () {
                this.$store.dispatch('setRefreshArr', 'cmpActProjs')
                this.$router.push({name: 'CmpActProj', params: {do: 'waiting'}})
            },
            toTimeout () {
                this.$store.dispatch('setRefreshArr', 'cmpActProjs')
                this.$router.push({name: 'CmpActProj', params: {do: 'timeout'}})
            },
            toOpening () {
                this.$store.dispatch('setRefreshArr', 'cmpActProjs')
                this.$router.push({name: 'CmpActProj', params: {do: 'opening'}})
            },
            toPrivate () {
                this.$store.dispatch('setRefreshArr', 'cmpActProjs')
                this.$router.push({name: 'CmpActProj', params: {do: 'private'}})
            },
            toClosing () {
                this.$store.dispatch('setRefreshArr', 'cmpActProjs')
                this.$router.push({name: 'CmpActProj', params: {do: 'closing'}})
            },
            toDelete () {
                this.$store.dispatch('setRefreshArr', 'cmpActProjs')
                this.$router.push({name: 'CmpActProj', params: {do: 'delete'}})
            },
            toAccessLimit () {
                this.$store.dispatch('setRefreshArr', 'cmpActProjs')
                this.$router.push({name: 'CmpActProj', params: {do: 'accesslimit'}})
            },
            toCmpGraph () {
                this.$router.push({name: 'CmpProjGraph'})
            },
            toLangGraph () {
                this.$router.push({name: 'CmpLangGraph'})
            }
        }
    }
</script>

<style lang="stylus" scoped>

</style>
